import { ref, onMounted } from 'vue'
import { getCurrentTheme, setTheme } from '@/utils/theme'
import lightLogo from '@/assets/img/lockerbot_logo.png'
import darkLogo from '@/assets/img/lockerbot_logo_dark.png'
import smallLightLogo from '@/assets/img/lockerbot_logo_small.png'
import smallDarkLogo from '@/assets/img/lockerbot_logo_small_dark.png'

// Global reactive theme state
const currentTheme = ref(getCurrentTheme())

// Theme composable
export function useTheme() {
  // Update theme function
  const updateTheme = (newTheme) => {
    setTheme(newTheme)
    currentTheme.value = newTheme
  }

  // Toggle theme function
  const toggleTheme = () => {
    const newTheme = currentTheme.value === 'light' ? 'dark' : 'light'
    updateTheme(newTheme)
  }

  // Initialize theme on mount
  onMounted(() => {
    currentTheme.value = getCurrentTheme()
  })

  return {
    currentTheme,
    updateTheme,
    toggleTheme,
    lightLogo,
    darkLogo,
    smallLightLogo,
    smallDarkLogo
  }
} 